<template>
  <td :class="column.class">
    <div v-if="column.component">
      <component :is="column.component" :row="row"
                 :app-scope="column.scope || appScope"
                 :value="getCellValue(column.name, row)"
                 :index="index"
                 v-bind="column.bindings || {}"
                 v-on="column.events || {}"
      ></component>
    </div>
    <div v-else>
      <span>{{ column.transform ? column.transform(row) : getCellValue(column.name, row) | cellFilter(column.filter, column.filterInput) }}</span>
    </div>
  </td>
</template>

<script>
import Vue from "vue";
import {get} from 'lodash'

export default {
  props: ["row", "column", "appScope", "index"],
  methods: {
    getCellValue(key = '', entry = {}) {
      return get(entry, key)
    },
  },filters: {
    cellFilter: function (val, type, input) {
      return type ? Vue.options.filters[type](val, input) : val;
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/mixins";

  //@include mobile() {
  //  td {
  //    display: inline-block !important;
  //  }
  //}
</style>
